import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchProducts = async (params = {}) => {
  const { data } = await api.get("/products", { params });
  return data.products;
};

export const fetchProduct = async (id) => {
  const { data } = await api.get(`/products/${id}`);
  return data;
};

export const fetchTestimonials = async (category = "all") => {
  const { data } = await api.get("/testimonials", { params: { category } });
  return data.testimonials;
};

export const subscribeNewsletter = async ({ email, name, source }) => {
  const { data } = await api.post("/newsletter", { email, name, source });
  return data;
};

export const sendContact = async (payload) => {
  const { data } = await api.post("/contact", payload);
  return data;
};

export const createCheckout = async ({ lookup_key, items, quantity = 1, customer_email, promotion_code_id }) => {
  const { data } = await api.post("/payments/checkout", {
    lookup_key, items, quantity, customer_email, promotion_code_id,
    origin_url: window.location.origin,
  });
  return data;
};

export const validateCoupon = async ({ code, subtotal_cents }) => {
  const { data } = await api.post("/coupons/validate", { code, subtotal_cents });
  return data;
};

export const getPaymentStatus = async (session_id) => {
  const { data } = await api.get(`/payments/status/${session_id}`);
  return data;
};
